module.exports = __webpack_public_path__ + "media/images/web/home/index/generic-4dca0e37796849d012205446c547fae0.jpg";